import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResetSaveButtonService } from 'src/app/services/reset-save-button.service';

@Component({
  selector: 'app-reset-save-button-group',
  templateUrl: './reset-save-button-group.component.html',
  styleUrls: ['./reset-save-button-group.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetSaveButtonGroupComponent {
  @Input() saveButtonText: string;
  @Input() showTickIcon: boolean;

  constructor(protected _rsbs: ResetSaveButtonService) {}
}
